import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * /kalkulator/ → permanent redirect to /tools/.
 * Provides a friendlier slug for the "Kalkulator" mega-menu entry while
 * keeping the actual hub at /tools/ to avoid duplicating content.
 */
export const Route = createFileRoute("/kalkulator/")({
  loader: () => {
    throw redirect({ to: "/tools/", code: 308 } as any);
  },
  component: () => null,
});